if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading-overlay__spinner").classList.remove(
          "hidden"
        );

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            console.log("Adding additional product(s)...");

            let products = [];
            let crossProductsCount = 0;
            //document.querySelector('#cart-notification-additionalproducts').innerHTML = "";

            let crossSellProducts = document.querySelectorAll(
              ".crosssell-container > .crosssell_product"
            );
            crossSellProducts.forEach((product) => {
              if (!product.querySelector(".checkbox-input").checked) {
                return;
              }
              let selectedVariant = product
                .querySelector("input")
                .getAttribute("variant_id");

              crossProductsCount++;

              products.push({
                id: selectedVariant,
                quantity: 1,
              });

              let product_handle = product.getAttribute("product_handle");

              fetch("/products/" + product_handle + ".js")
                .then(function (response) {
                  return response.json();
                })
                .then(function (productObject) {
                  let variant = productObject.variants.find(function (variant) {
                    return variant.id == selectedVariant;
                  });

                  const options = [];

                  if (product.classList.contains("variants")) {
                    variant.options.forEach(function (value, i) {
                      options.push(`
                        <div class="product-option">
                          <dt>${productObject.options[i].name}:</dt>
                          <dd>${value}</dd>
                        </div>
                      `);
                    });
                  }

                  let image;

                  if (
                    product.classList.contains("variants") &&
                    variant.featured_image != null
                  ) {
                    image = variant.featured_image.src;
                  } else {
                    image = productObject.featured_image;
                  }

                  //let image = product.classList.contains("variants") ? variant.featured_image.src : productObject.featured_image;

                  /*
                  document.querySelector('#cart-notification-additionalproducts').insertAdjacentHTML("beforeend",`
                  <div class="cart-notification-product">
                    <div class="cart-notification-product__image global-media-settings">
                      <img src="${image}" width="70" height="70">
                    </div>
                    <div>
                      <h3 class="cart-notification-product__name h4">${productObject.title}</h3>
                      <dl>
                        ${options.join("")}
                      </dl>
                    </div>
                  </div>
                  `);
                  */

                  //console.log("Product: " + JSON.stringify(productObject) + ", Variant: " + JSON.stringify(variant));
                });

              console.log(
                "Product added: " +
                  selectedVariant +
                  ", Variant ID: " +
                  JSON.stringify(products)
              );
            });

            if (products.length > 0) {
              console.log("Products: " + JSON.stringify(products));

              CartJS.addItems(products, {
                success: function (data, textStatus, jqXHR) {
                  // Refresh cart drawer
                  fetch("/?section_id=cart-drawer")
                    .then((response) => response.text())
                    .then((html) => {
                      const parser = new DOMParser();
                      const doc = parser.parseFromString(html, "text/html");
                      const newDrawer = doc.querySelector("cart-drawer");
                      const existingDrawer =
                        document.querySelector("cart-drawer");
                      if (newDrawer && existingDrawer) {
                        existingDrawer.innerHTML = newDrawer.innerHTML;
                      }
                    })
                    .catch((error) =>
                      console.error("Error updating cart drawer:", error)
                    );

                  // Update cart badge
                  fetch("/cart.js")
                    .then((response) => response.json())
                    .then((cart) => {
                      const badge = document.querySelector(
                        "div.cart-count-bubble > span:first-child"
                      );
                      if (badge) {
                        badge.textContent = cart.item_count;
                      }
                    })
                    .catch((error) =>
                      console.error("Error updating cart badge:", error)
                    );

                  // Open cart drawer
                  document.dispatchEvent(new CustomEvent("cart:open"));
                },
                error: function (jqXHR, textStatus, errorThrown) {
                  console.error("Error adding items:", errorThrown);
                },
              });

              //this.cart.saveCrossSellProducts(products, crossProductsCount);
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
                cartData: response,
              });
            this.error = false;

            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading-overlay__spinner").classList.add(
              "hidden"
            );
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
